export enum Creator {
    Agent = 0,
    Customer = 1
}